module.exports = __webpack_public_path__ + "img/LogoSm.acf42803.jpg";